module.exports = __webpack_public_path__ + "img/IMG_9022_L_WoodMatted_MockedUp.7561532d.jpg";